const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/DashboardCard.tsx';
import * as React from 'react';
import { ReactNode } from 'react';
import Icon from '@mui/material/Icon';
import { cx } from '@emotion/css';
import { Card, CardActionArea, CardContent } from '@mui/material';
import Grid from '@mui/material/Grid';
import {
    cardContentWithIconColumnClass,
    headerIconStyle,
} from 'App/pages/DashboardPage/Components/appointmentCards/styles';

type Props = {
    children: ReactNode;
    iconClass: string;
    onClick?: () => void;
    hasData?: boolean;
    isDataLoading?: boolean;
};

export const DashboardCard = (props: Props) => {
    const hasData = props.hasData ?? true;
    const isDataLoading = props.isDataLoading ?? false;

    if (isDataLoading) {
        return null;
    }

    if (!hasData) return null;

    const cardContent = (
        <CardContent className={cardContentWithIconColumnClass}>
            <div>
                <Icon className={cx(props.iconClass, headerIconStyle)} component="span" />
            </div>
            <div>{props.children}</div>
        </CardContent>
    );

    return (
        <Grid size={{ xs: 12 }}>
            <Card>
                {props.onClick ? <CardActionArea onClick={props.onClick}>{cardContent}</CardActionArea> : cardContent}
            </Card>
        </Grid>
    );
};
